"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MailboxType;
(function (MailboxType) {
    MailboxType[MailboxType["UserMailbox"] = 1] = "UserMailbox";
    MailboxType[MailboxType["GroupMailbox"] = 2] = "GroupMailbox";
    MailboxType[MailboxType["Unknown"] = 3] = "Unknown";
})(MailboxType = exports.MailboxType || (exports.MailboxType = {}));
let groupMailboxTypes = ["PublicDL", "PrivateDL", "GroupMailbox", "PublicFolder"];
let userMailboxTypes = ["User", "Contact", "InternalMailbox", "ExternalMailbox", "OneOff", "Mailbox", "Guest", "ImplicitContact", "ChatImplicitContact"];
function getType(mailboxType) {
    if (groupMailboxTypes.indexOf(mailboxType) != -1) {
        return MailboxType.GroupMailbox;
    }
    else if (userMailboxTypes.indexOf(mailboxType) != -1) {
        return MailboxType.UserMailbox;
    }
    else {
        return MailboxType.Unknown;
    }
}
exports.getType = getType;
